











































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/store/api';
@Component({})
export default class ShowSlidesInfo extends Vue {
  info: any = {};

  goto() {
    if (process.env.NODE_ENV !== '_development') {
      this.openFullscreen();
    }
    this.$router.push({
      name: 'presentation-shared',
      params: { DocumentId: this.$route.params.DocumentId },
    });
  }

  async mounted() {
    this.info = await api.getSharedDocumentInfo(this.$route.params.DocumentId);
  }

  openFullscreen() {
    const elem: any = document.documentElement;
    if (elem.requestFullscreen) {
      return elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      return elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      return elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      return elem.msRequestFullscreen();
    }
  }
}
